import {
  ModalOverlay,
  ModalContent,
  ModalContentProps,
  ModalHeader,
  ModalHeaderProps,
  ModalOverlayProps,
} from '@chakra-ui/react';
import { borders } from '../theme';
import React from 'react';

export const CustomModalOverlay = ({ ...rest }: ModalOverlayProps) => (
  <ModalOverlay bg="blackAlpha.200" backdropFilter="blur(10px)" {...rest} />
);

export const CustomModalContent = React.forwardRef(
  ({ children, ...rest }: ModalContentProps, ref) => {
    return (
      <ModalContent
        bg="c-107"
        border={borders.normal}
        borderRadius={'2rem'}
        boxShadow="10px 20px 50px 0px #0000004D"
        {...rest}
        ref={ref}
      >
        {children}
      </ModalContent>
    );
  }
);

export const CustomModalHeader = ({ children, ...rest }: ModalHeaderProps) => (
  <ModalHeader
    textAlign={'center'}
    textTransform={'capitalize'}
    h={'4.5rem'}
    fontSize={'xl'}
    fontWeight={'semibold'}
    py={6}
    {...rest}
  >
    {children}
  </ModalHeader>
);
